export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20editorial%20composition%20with%20warm%20deep%20red%20and%20dark%20gray%20gradient%20background%2C%20magazine%20cover%20style%20with%20geometric%20overlays%20and%20subtle%20newspaper%20texture%2C%20modern%20media%20and%20entertainment%20industry%20aesthetic%2C%20high%20contrast%20with%20rich%20warm%20tones%2C%20no%20text%2C%20editorial%20design%20atmosphere&width=1800&height=900&seq=hero-bg-51cg-2026&orientation=landscape"
          alt="51吃瓜网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Text Column */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Pre-title tags */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-5">
              <span className="px-3 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full whitespace-nowrap">
                实时更新
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-background-50/20 text-background-50 backdrop-blur-sm rounded-full whitespace-nowrap">
                全网最热
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full whitespace-nowrap">
                独家爆料
              </span>
            </div>

            {/* H1 */}
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              51吃瓜网官网
              <br />
              <span className="text-accent-400">全网猛料第一站</span>
            </h1>

            {/* Slogan */}
            <p className="text-lg md:text-xl text-background-50/80 font-medium mb-6">
              吃瓜不迷路，爆料看这里
            </p>

            {/* Description */}
            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              51吃瓜网官网聚焦明星网红八卦最新动态，覆盖全网猛料汇总及热点人物内幕。
              每日实时更新51吃瓜爆料与51吃瓜黑料，涵盖娱乐圈、直播圈、网红圈等多维度热门话题。
              我们致力于打造吃瓜爆料第一站，让你不错过任何一个热点瓜。
              当前站内已收录近万条爆料内容，日活吃瓜群众超百万，热门话题每小时刷新。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center lg:text-left">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">10W+</p>
                <p className="text-xs text-background-50/60 mt-1">全网爆料收录</p>
              </div>
              <div className="text-center lg:text-left">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">24h</p>
                <p className="text-xs text-background-50/60 mt-1">全天候实时更新</p>
              </div>
              <div className="text-center lg:text-left">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">100+</p>
                <p className="text-xs text-background-50/60 mt-1">每日新增热点</p>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                立即吃瓜
              </a>
              <a
                href="#topics"
                className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium border border-background-50/30 rounded-lg hover:bg-background-50/25 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                浏览话题
              </a>
            </div>
          </div>

          {/* Visual Column */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20collage%20style%20with%20floating%20magazine%20covers%20and%20headlines%2C%20warm%20red%20and%20dark%20tones%2C%20spotlight%20effect%20on%20center%2C%20celebrity%20silhouette%20vibe%2C%20paparazzi%20flash%20aesthetic%2C%20editorial%20art%20direction%2C%20cinematic%20lighting%2C%20no%20recognizable%20faces&width=1200&height=900&seq=hero-visual-51cg-2026&orientation=landscape"
                alt="51吃瓜网今日热门爆料主视觉"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute bottom-3 left-3 right-3 bg-background-950/70 backdrop-blur-md rounded-xl px-4 py-3">
                <p className="text-xs text-background-50/80 font-medium">
                  <span className="text-accent-400 font-bold">HOT</span> 今日最热：某顶流男星深夜密会引发全网震动，当事人回应来了...
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}